import React, { Fragment, useEffect, useRef, useState } from 'react'
import { ErrorMessage, Field } from 'formik';
import classNames from 'classnames';
import "./styles/SelectWithCustomOption.scss";
import { useIntl } from 'react-intl';
import useClickOutside from 'scenes/ProjectMultiStepForm/hooks/useClickOutside';
import useCapitalizedLetters from 'scenes/ProjectMultiStepForm/hooks/useCapitalizedLetters';

const SelectWithCustomOption = ({ 
  name, 
  initialValue = "",
  selectValues, 
  placeholderMessage, 
  updateField,
  customOptionText
}) => {
  const intl = useIntl();
  const customInputRef = useRef(null);
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedValue, setSelectedValue] = useState(initialValue);
  const { elementRef } = useClickOutside(setShowDropdown);
  const { capitalizedFields, handleApplyCapitalizedLetters } = useCapitalizedLetters();

  useEffect(() => {
    setSelectedValue(initialValue);
  }, [initialValue]);

  const handleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleChangeInput = (e) => {
    const value = e.target.value;
    setSelectedValue(value);

    /* Update field when the selected option is equal to customOptionText */
    handleApplyCapitalizedLetters("applicationByUser", value);
    updateField("applicationByUser", value);
  };

  const handlePressEnterInput = (e) => {
    if (e.key === "Enter") {
      setShowDropdown(false);
      setShowCustomInput(false);
    }
  };

  const handleOptionSelection = (e) => {
    if (e.target.innerText === customOptionText) {
      updateField(name, "");
      setShowCustomInput(true);
      setShowDropdown(false);
    } else {
      setShowCustomInput(false);
      setSelectedValue(e.target.innerText);
      updateField(name, e.target.innerText);
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    if (showCustomInput && customInputRef.current) {
      customInputRef.current.focus(); /* Focus on custom input after do click in customOptionText */
    }
  }, [showCustomInput]);
  
  return (
    <Fragment>
      <div
        ref={elementRef}
        className="custom-select form-control bg-transparent col-12 position-relative"
        onClick={handleShowDropdown}
      >
        <div className="select__default-option">
          {showCustomInput ? (
            <Field
              id="applicationByUser"
              type="text"
              name="applicationByUser"
              value={capitalizedFields?.applicationByUser}
              className="select-input__custom bg-transparent col-12 border-0 px-0"
              innerRef={customInputRef}
              placeholder={intl.formatMessage({
                id: "ApplicationSelect.whichOne",
              })}
              onChange={handleChangeInput}
              onKeyDown={handlePressEnterInput}
            />
          ) : (
            !selectedValue ? placeholderMessage : selectedValue
          )}
        </div>
        {showDropdown && (
          <div className="application-options bg-white p-3 mt-1">
            {selectValues.map(({ id, label }, index) => (
              <div
                key={id}
                className={classNames({
                  "select__current-option": true,
                  "select__current-option-with-border":
                    index !== selectValues.length - 1,
                })}
                onClick={handleOptionSelection}
              >
                {label}
              </div>
            ))}
          </div>
        )}
        <Field
          id={name}
          name={name}
          component="select"
          className="select--field"
        />
      </div>
      <ErrorMessage
        className="form-error-message"
        component="div"
        name={name}
      />
    </Fragment>
  );
}

export default SelectWithCustomOption;